export function getDeviceInfo(isList,panduan,noCheckList,listSeletList,itemPanduan,itemsNoselectList,itemsDataList){
	if (isList == true) {
		if (panduan == true) {
			if (noCheckList.length == 0) {
				return ['all',[]];
			} else {
				let devices_info = [];
				noCheckList.forEach((ele) => {
					devices_info.push({
						id: ele.id,
						sn: ele.sn,
						name: ele.name,
						type_id: ele.type_id,
						system_version:ele.system_version
					});
				});
				return ['filter',devices_info]
			}
		} else {
			if (listSeletList.length == 0) {
				return false;
			} else {
				let devices_info = [];
				listSeletList.forEach((ele) => {
					devices_info.push({
						id: ele.id,
						sn: ele.sn,
						name: ele.name,
						type_id: ele.type_id,
						system_version:ele.system_version
					});
				});
				return ['multiple',devices_info]
			}
		}
	} else {
		//缩率图模式下
		if (itemPanduan == true) {
			if (itemsNoselectList.length == 0) {
				return ['all',[]];
			} else {
				let devices_info = [];
				itemsNoselectList.forEach((ele) => {
					devices_info.push({
						id: ele.id,
						sn: ele.sn,
						name: ele.name,
						type_id: ele.type_id,
						system_version:ele.system_version
					});
				});
				return ['filter',devices_info]
			}
		} else {
			if (itemsDataList.length == 0) {
				return false;
			} else {
				let devices_info = [];
				itemsDataList.forEach((ele) => {
					devices_info.push({
						id: ele.id,
						sn: ele.sn,
						name: ele.name,
						type_id: ele.type_id,
						system_version:ele.system_version
					});
				});
				return ['multiple',devices_info]
			}
		}
	}
}